// Zero-filled periods for the "Alarm raises" chart (2026-10-30).
// GET alarms/log/series returns only the periods that have raises, each as the
// start of its local hour or day. This builds every period from start to end
// in the browser's time zone and takes each one's counts from the row with the
// same start time, else zeros. Pure and without imports, so plain node can
// check it (TZ=Europe/London, across the 25 October clock change).

const HOUR_MS = 60 * 60 * 1000;
const PRIORITIES = ["CRITICAL", "MAJOR", "MINOR", "WARNING"];

// Per hour up to 7 calendar days, per day beyond. Calendar days, not 7 x 24
// hours: the default 7 days are 169 hours across the autumn clock change
// (code review 2026-10-30).
export function pickInterval(start, end) {
  const limit = new Date(start);
  limit.setDate(limit.getDate() + 7);
  return new Date(end).getTime() <= limit.getTime() ? "hour" : "day";
}

export function fillPeriods(rows, start, end, interval) {
  const byTime = {};
  (rows || []).forEach((row) => {
    byTime[new Date(row.t).getTime()] = row;
  });

  // the start of the local day or hour that holds `start`
  const point = new Date(start);
  if (interval === "day") point.setHours(0, 0, 0, 0);
  else point.setMinutes(0, 0, 0);

  // the end is exclusive, as the server's dateTo (code review 2026-10-30)
  const last = new Date(end).getTime();
  const points = [];
  while (point.getTime() < last) {
    const row = byTime[point.getTime()] || {};
    const item = { t: point.getTime() };
    PRIORITIES.forEach((priority) => {
      item[priority] = row[priority] || 0;
    });
    points.push(item);
    // Days step by calendar day, so local midnight stays aligned over a clock
    // change; back to midnight after each step for zones whose clocks change
    // at midnight (code review 2026-10-30). Hours step by one real hour:
    // stepping the local hour would skip the repeated hour when the clocks go
    // back.
    if (interval === "day") {
      point.setDate(point.getDate() + 1);
      point.setHours(0, 0, 0, 0);
    } else point.setTime(point.getTime() + HOUR_MS);
  }
  return points;
}
